import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { SearchBarType } from "@/components/dynamic-form/constants";
import { getSearchConfig } from "@/components/dynamic-form/helper/getSearchConfig";
const searchConfig = getSearchConfig(() => {
  const t = getTranslateNsT("center");
  return [
    {
      type: SearchBarType.Input,
      field: "userName",
      label: "",
      props: {
        placeholder: t("picture_rewards_nickname_palceholder"),
        style: { width: "240px" },
      },
    },
  ];
});

export function useSearchConfig() {
  return { searchConfig };
}
